module.exports = __webpack_public_path__ + "static/media/B-flat-Triads.a886dff9.png";